import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog as MuiDialog } from "@mui/material";
export const Dialog = (props)=>{
    return /*#__PURE__*/ _jsx(MuiDialog, {
        "data-component": props['data-component'] ?? 'dialog',
        "data-testid": props['data-testid'],
        fullScreen: props.fullScreen,
        fullWidth: props.fullWidth,
        maxWidth: props.maxWidth,
        onClose: props.locked ? undefined : props.onClose,
        open: !!(props.locked || props.isOpen),
        slotProps: {
            paper: {
                sx: (theme)=>({
                        borderRadius: props.fullScreen ? 0 : theme.spacing(1.5),
                        margin: theme.spacing(1),
                        maxHeight: 'calc(100% - 1rem)',
                        ...props.fullHeight && {
                            height: '100%'
                        },
                        /** declared last so the media query wins over fullHeight's height */ [theme.breakpoints.down('sm')]: {
                            borderRadius: 0,
                            height: '100%',
                            margin: 0,
                            maxHeight: '100%',
                            maxWidth: '100%',
                            width: '100%'
                        }
                    })
            }
        },
        children: props.children
    });
};
Dialog.displayName = 'Dialog';

//# sourceMappingURL=Dialog.js.map